"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.useZIndexManager = void 0;
const react_1 = require("react");
let zIndexStack = [];
if (!window.__INTERNAL_HAS_ZSTACK_KEYDOWN_LISTENER__) {
    window.__INTERNAL_HAS_ZSTACK_KEYDOWN_LISTENER__ = true;
    document.addEventListener('keydown', (e) => {
        var _a;
        const handler = (_a = zIndexStack[zIndexStack.length - 1]) === null || _a === void 0 ? void 0 : _a.keyDownHandler;
        handler === null || handler === void 0 ? void 0 : handler(e);
    });
}
function useZIndexManager({ onKeyPress, onChange } = {}) {
    const [zIndexId] = (0, react_1.useState)(() => Math.random().toString(16).slice(2));
    const api = (0, react_1.useMemo)(() => ({
        hasChildren: () => {
            return !!zIndexStack.length && zIndexStack[zIndexStack.length - 1].id !== zIndexId;
        },
        id: zIndexId
    }), [zIndexId]);
    (0, react_1.useEffect)(() => {
        var _a;
        const prevItem = zIndexStack[zIndexStack.length - 1] || null;
        zIndexStack.push({
            id: zIndexId,
            parentId: (_a = prevItem === null || prevItem === void 0 ? void 0 : prevItem.id) !== null && _a !== void 0 ? _a : null,
            onChangeHandler: () => {
                onChange === null || onChange === void 0 ? void 0 : onChange(api);
            },
            keyDownHandler: (e) => {
                onKeyPress === null || onKeyPress === void 0 ? void 0 : onKeyPress(e);
            }
        });
        prevItem === null || prevItem === void 0 ? void 0 : prevItem.onChangeHandler();
        return () => {
            const itemIdx = zIndexStack.findIndex(({ id }) => id === zIndexId);
            const prevItem = zIndexStack[itemIdx - 1];
            zIndexStack = zIndexStack.filter(({ id }) => id !== zIndexId);
            prevItem === null || prevItem === void 0 ? void 0 : prevItem.onChangeHandler();
        };
    }, [api, onChange, onKeyPress, zIndexId]);
    (0, react_1.useEffect)(() => {
        for (let i = 0; i < zIndexStack.length; i++) {
            if (zIndexStack[i].id === zIndexId) {
                zIndexStack[i].keyDownHandler = (e) => {
                    onKeyPress === null || onKeyPress === void 0 ? void 0 : onKeyPress(e);
                };
                zIndexStack[i].onChangeHandler = () => {
                    onChange === null || onChange === void 0 ? void 0 : onChange(api);
                };
            }
        }
    }, [onKeyPress, onChange, zIndexId, api]);
    return api;
}
exports.useZIndexManager = useZIndexManager;
//# sourceMappingURL=zIndexManager.js.map